// Static audience filter field definitions. Must stay in sync with the
// hardcoded sets in `_shared/audienceFilters.ts`. FlightForm composes this
// catalog with active custom-attribute definitions; every field-list consumer
// in that form must use the composed memo so custom fields remain available.
export const STATIC_AUDIENCE_FILTER_FIELDS = [
  // Native Zuora targeting. Both match the contact's CURRENT ACTIVE subscriptions only — a
  // cancelled member never matches on a plan they used to hold.
  {
    value: "zuora_plan_name",
    label: "Zuora Plan (coverage)",
    type: "zuora",
    group: "Membership",
  },
  {
    value: "product_names",
    label: "Zuora Product Family",
    type: "zuora",
    group: "Membership",
  },
  {
    value: "member_status",
    label: "Member Status",
    type: "text",
    group: "Membership",
  },
  {
    value: "is_usls_member",
    label: "Is USLS Member",
    type: "boolean",
    group: "Membership",
  },
  {
    value: "has_active_subscription",
    label: "Has Active Subscription",
    type: "boolean",
    group: "Membership",
  },
  {
    value: "paying_member",
    label: "Paying Member",
    type: "boolean",
    group: "Membership",
  },
  {
    value: "member_expiration_date",
    label: "Member Expiration Date",
    type: "date",
    group: "Membership",
  },
  {
    value: "member_start_date",
    label: "Member Start Date",
    type: "date",
    group: "Membership",
  },
  {
    value: "member_end_date",
    label: "Member End Date",
    type: "date",
    group: "Membership",
  },
  {
    value: "member_renewal_date",
    label: "Member Renewal Date",
    type: "date",
    group: "Membership",
  },
  {
    value: "last_invoice_date",
    label: "Last Invoice Date",
    type: "date",
    group: "Membership",
  },
  {
    value: "contact_type",
    label: "Contact Type",
    type: "text",
    group: "Contact",
  },
  { value: "status", label: "Status", type: "text", group: "Contact" },
  { value: "source", label: "Source", type: "text", group: "Contact" },
  { value: "state", label: "State", type: "text", group: "Contact" },
  { value: "city", label: "City", type: "text", group: "Contact" },
  {
    value: "postal_code",
    label: "Postal Code",
    type: "text",
    group: "Contact",
  },
  { value: "country", label: "Country", type: "text", group: "Contact" },
  {
    value: "email_opt_in",
    label: "Email Opt-In",
    type: "boolean",
    group: "Communication",
  },
  {
    value: "sms_opt_in",
    label: "SMS Opt-In",
    type: "boolean",
    group: "Communication",
  },
  {
    // NeverBounce email quality. Evaluated server-side against
    // email_validation_results (see _shared/audienceFilters.ts). 'invalid' is
    // already auto-excluded from every send by the always-on guard; this filter
    // lets a flight further target/exclude valid/risky/unvalidated.
    value: "email_quality",
    label: "Email quality (NeverBounce)",
    type: "email_quality",
    group: "Communication",
  },
  {
    // Email-open engagement (virtual, daily-refreshed contact_email_engagement).
    // Boolean is_true / is_false: opened an email within the last 30 / 90 days.
    // Evaluated server-side against contact_email_engagement (see
    // _shared/audienceFilters.ts) so count == preview == send.
    value: "opened_email_30d",
    label: "Opened email (last 30 days)",
    type: "boolean",
    group: "Communication",
  },
  {
    value: "opened_email_90d",
    label: "Opened email (last 90 days)",
    type: "boolean",
    group: "Communication",
  },
  {
    value: "is_archived",
    label: "Is Archived",
    type: "boolean",
    group: "Other",
  },
  {
    value: "tags",
    label: "Tag",
    type: "tag",
    group: "Other",
  },
  {
    // List membership - target "in base list, but on / not on another list".
    // The condition value is a list_id.
    value: "list_membership",
    label: "List membership",
    type: "list",
    group: "Other",
  },
] as const;
